import visa from 'assets/images/payment/visa.svg';
import mastercard from 'assets/images/payment/mastercard.svg';
import visaDebit from 'assets/images/payment/visa-debit.svg';
import sepa from 'assets/images/payment/sepa.svg';
import maestro from 'assets/images/payment/maestrocard.svg';
import jcb from 'assets/images/payment/jcbcard.svg';
import discovercard from 'assets/images/payment/discovercard.svg';
import dinersClub from 'assets/images/payment/diners-club-international.svg';
import paypal from 'assets/images/payment/paypal.svg';
import ideal from 'assets/images/payment/ideal.svg';
import interac from 'assets/images/payment/interac.svg';
// import crypto from 'assets/images/payment/crypto.svg';
import americanExpress from 'assets/images/payment/american-express.svg';
import qiwi from 'assets/images/payment/qiwi.svg';
import ccbill_pay from 'assets/images/payment/ccbillpay.svg';
import segpay from 'assets/images/payment/segpay.svg';
import paysafecard from 'assets/images/payment/paysafecard.svg';
import ccbill from 'assets/images/payment/ccbill.svg';
import epoch from 'assets/images/payment/epoch.svg';
import debitCard from 'assets/images/payment/debitcard.svg';
import achOnline from 'assets/images/payment/ach.svg';
import directpay from 'assets/images/payment/directPayEU.svg';
import wallet from 'assets/images/payment/mms_wallet.svg';
// import boomfi from 'assets/images/payment/boomfi.svg';
import crypto from 'assets/images/payment/new-crypto.svg';
import vendo from 'assets/images/payment/vendo.png';
import payByBank from 'assets/images/payment/pay-by-bank.svg';
import payByBankDark from 'assets/images/payment/pay_by_bank_dark.svg';
import cryptoDark from 'assets/images/payment/crypto-dark-logo.svg';
import paypalLogo from 'assets/images/payment/paypal-logo.svg';

const paymentImg = {
   debitCard,
   americanExpress,
   ccbill,
   achOnline,
   paysafecard,
   qiwi,
   directpay,
   interac,
   maestro,
   dinersClub,
   discoverNetwork: discovercard,
   sepa,
   jcb,
   paypal: paypal,
   maestro_card: maestro,
   debit: debitCard,
   epoch_paypal: paypal,
   segpay_paypal: paypal,
   diners_club_international_card: dinersClub,
   discover_card: discovercard,
   discover: discovercard,
   jcb_card: jcb,
   ccbill_pay: ccbill_pay,
   ideal: ideal,
   deal: ideal,
   visa_card: visa,
   visaCard: visa,
   mastercard: mastercard,
   master_card: mastercard,
   visa_debit: visaDebit,
   visa,
   epoch,
   segpay,
   mms_wallet: wallet,
   boomfi: crypto,
   segpay_crypto: crypto,
   crypto,
   vendo,
   payByBank,
   pay_by_bank: payByBank,
   payByBankDark: payByBankDark,
   cryptoDark,
   paypal_logo: paypalLogo,
};
export default paymentImg;
